import React, { PureComponent, Fragment, memo } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import Articulos from './detalleArticulos.jsx';

class detalleArticulosSuc extends PureComponent {

    render() {
        const{articulos, sucursalArt, sucFact} = this.props;
        const Art = articulos.filter((item) => item.Suc_Id == sucursalArt); 
        let NombreSuc = '';
        let numTraslado = '';   
        if (Art.length > 0) {
             NombreSuc = Art[0].Suc_Nombre;
            numTraslado = Art[0].Mov_Id;
            const traslado = (sucursalArt != sucFact? <div className="row"><div className="col mt-2"><p className="traslado">Número de traslado</p></div><div className="col mt-2"><p className="traslado"><span className="dot"></span>{numTraslado}</p></div></div> : null)
        return (
            <Fragment>

                <div className="row">
                    <div className="col mt-4">
                        <h5>{`${sucursalArt == sucFact ? "Sucursal que Apoya" : "Sucursal de Apoyo"}`} </h5>
                        <h4>{NombreSuc}</h4>
                    </div>
                </div>
                {traslado}
                <div className="row">
                    <div className="col">
                        <div className="lista">
                            <Articulos
                            articulos={Art}
                            />
                        </div>
                    </div>
                </div>
            </Fragment>

        )
        }else{
            return (
            <Fragment> </Fragment>
            )

        }
    }

}
const mapStateToProps = state => {
    return {
        token: state.usuario.token,
        usuarioLogueado: state.usuario.usuarioLogueado,
        empresa: state.parametros.empresa,
        sucursal: state.parametros.sucursal,
        callCenter: state.parametros.callCenter
    };
};
export default connect(mapStateToProps)(withRouter(memo(detalleArticulosSuc)));
